"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RagIndexStatus = void 0;
exports.RagIndexStatus = {
    Created: "created",
    Processing: "processing",
    Failed: "failed",
    Succeeded: "succeeded",
    RagLimitExceeded: "rag_limit_exceeded",
    DocumentTooSmall: "document_too_small",
};
